import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessOverviewCalendarRoute: InvariantJiraRoute = {
	name: 'classic-business-overview-calendar',
	path: '/jira/core/overviews/:overviewId/calendar',
	exact: true,
};
